import { ref } from '@vue/reactivity'

const needsProductionStopOptions = [
  { label: 'Não', value: 1, color: '#2196F3' },
  { label: 'Equip.', value: 2, color: '#4CAF50' },
  { label: 'Parcial', value: 3, color: '#ff9800' },
  { label: 'Total', value: 4, color: '#f44336' },
]

const needsExecutionAtSpecialTimesOptions = [
  { label: 'Não', value: 1 },
  { label: 'Noturno', value: 2 },
  { label: 'Fim de Semana', value: 3 },
]

const needsDisconnectFromElectricalNetworkOptions = [
  { label: 'Equip.', value: 1, color: '#f44336' },
  { label: 'Geral', value: 2, color: '#4CAF50' },
]

const controlledAccessAreaOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const accessDifficultyOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const limitedLengthOfStayOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const limitedWorkSpaceOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const highTemperatureSurfaceOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const involvesSpecialJobsOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const needsSpecialEpiOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const otherDifficultiesOptions = [
  { label: 'Não', value: 0, color: '#f44336' },
  { label: 'Sim', value: 1, color: '#4CAF50' },
]

const needsProductionStopOption = ref()
const timeMeasurement = ref()
const needsExecutionAtSpecialTimesOption = ref()
const needsDisconnectFromElectricalNetworkOption = ref()
const controlledAccessAreaOption = ref()
const limitedLengthOfStayOption = ref()
const limitedLengthOfStayDetails = ref()
const accessDifficultyOption = ref()
const accessDifficultyDetails = ref()
const limitedWorkSpaceOption = ref()
const limitedWorkSpaceDetails = ref()
const highTemperatureSurfaceOption = ref()
const involvesSpecialJobsOption = ref()
const involvesSpecialJobsDetails = ref()
const needsSpecialEpiOption = ref()
const needsSpecialEpiDetails = ref()
const otherDifficultiesOption = ref()
const otherDifficultiesDetails = ref()

export default function useActionPlanImplementationDifficultiesForm() {
  const clearForm = () => {
    needsProductionStopOption.value = ''
    timeMeasurement.value = ''
    needsExecutionAtSpecialTimesOption.value = ''
    needsDisconnectFromElectricalNetworkOption.value = ''
    controlledAccessAreaOption.value = ''
    limitedLengthOfStayOption.value = ''
    limitedLengthOfStayDetails.value = ''
    accessDifficultyOption.value = ''
    accessDifficultyDetails.value = ''
    limitedWorkSpaceOption.value = ''
    limitedWorkSpaceDetails.value = ''
    highTemperatureSurfaceOption.value = ''
    involvesSpecialJobsOption.value = ''
    involvesSpecialJobsDetails.value = ''
    needsSpecialEpiOption.value = ''
    needsSpecialEpiDetails.value = ''
    otherDifficultiesOption.value = ''
    otherDifficultiesDetails.value = ''
  }

  const fillForm = (data) => {
    needsProductionStopOption.value = data.needs_production_stop || 1
    timeMeasurement.value = data.time_measurement || ''
    needsExecutionAtSpecialTimesOption.value =
      data.needs_execution_at_special_times || 1
    needsDisconnectFromElectricalNetworkOption.value =
      data.needs_disconnect_from_electrical_network || 1
    controlledAccessAreaOption.value = data.controlled_access_area ? 1 : 0
    limitedLengthOfStayOption.value = data.limited_length_of_stay ? 1 : 0
    limitedLengthOfStayDetails.value = data.limited_length_of_stay_details || ''
    accessDifficultyOption.value = data.access_difficulty ? 1 : 0
    accessDifficultyDetails.value = data.access_difficulty_details || ''
    limitedWorkSpaceOption.value = data.limited_work_space ? 1 : 0
    limitedWorkSpaceDetails.value = data.limited_work_space_details || ''
    highTemperatureSurfaceOption.value = data.high_temperature_surface ? 1 : 0
    involvesSpecialJobsOption.value = data.involves_special_jobs ? 1 : 0
    involvesSpecialJobsDetails.value = data.involves_special_jobs_details || ''

    needsSpecialEpiOption.value = data.needs_special_epi ? 1 : 0
    needsSpecialEpiDetails.value = data.needs_special_epi_details || ''
    otherDifficultiesOption.value = data.other_difficulties ? 1 : 0
    otherDifficultiesDetails.value = data.other_difficulties_details || ''
  }

  return {
    needsProductionStopOptions,
    needsExecutionAtSpecialTimesOptions,
    needsDisconnectFromElectricalNetworkOptions,
    controlledAccessAreaOptions,
    accessDifficultyOptions,
    limitedLengthOfStayOptions,
    limitedWorkSpaceOptions,
    highTemperatureSurfaceOptions,
    involvesSpecialJobsOptions,
    needsSpecialEpiOptions,
    otherDifficultiesOptions,

    //
    needsProductionStopOption,
    timeMeasurement,
    needsExecutionAtSpecialTimesOption,
    needsDisconnectFromElectricalNetworkOption,
    controlledAccessAreaOption,
    limitedLengthOfStayOption,
    limitedLengthOfStayDetails,
    accessDifficultyOption,
    accessDifficultyDetails,
    limitedWorkSpaceOption,
    limitedWorkSpaceDetails,
    highTemperatureSurfaceOption,
    involvesSpecialJobsOption,
    involvesSpecialJobsDetails,
    needsSpecialEpiOption,
    needsSpecialEpiDetails,
    otherDifficultiesOption,
    otherDifficultiesDetails,

    clearForm,
    fillForm,
  }
}
